module.exports = __webpack_public_path__ + "static/media/pov_whole_polytope_3_3_5_cell600.cde8fea4.png";